/**
 * 403 page when the user lacks permission.
 */
import * as React from 'react';
import { ShieldX } from 'lucide-react';
import { UNAUTH_PARTICLE_INDICES } from '@/components/auth/auth-configs';
import { unauthParticleClass } from '@/components/auth/auth-utils';
import { getErrorMessage } from '@/utils/errors-utils';

/** Full-screen 403 when the user has no interface_elements for the route. */
export const UnauthorizedPage: React.FC = () => {
  function renderParticle(index: number): React.ReactNode {
    return (
      <div key={`unauth-particle-${index}`} className={unauthParticleClass('unauth', index)} />
    );
  }

  return (
    <div className="unauth-root">
      <div className="unauth-orb unauth-orb-1" />
      <div className="unauth-orb unauth-orb-2" />
      <div className="unauth-orb unauth-orb-3" />

      <div className="unauth-ring unauth-ring-1" />
      <div className="unauth-ring unauth-ring-2" />
      <div className="unauth-ring unauth-ring-3" />

      {UNAUTH_PARTICLE_INDICES.map(renderParticle)}

      <div className="unauth-card">
        <div className="unauth-icon-halo" />

        <div className="unauth-icon-wrap">
          <div className="unauth-icon-ring" />
          <div className="unauth-icon-box">
            <ShieldX className="unauth-icon" strokeWidth={1.4} />
          </div>
        </div>

        <div className="unauth-code">403</div>

        <div className="unauth-scan" />

        <h1 className="unauth-title">{getErrorMessage('accessDeniedTitle')}</h1>

        <p className="unauth-desc">{getErrorMessage('accessDeniedPageDetail')}</p>

        <div className="unauth-tag">
          <span className="unauth-tag-dot" />
          <span>Erreur&nbsp;403&nbsp;—&nbsp;Forbidden</span>
        </div>
      </div>
    </div>
  );
};
